import React from 'react';
import { useTranslation } from '../i18n';

export default function LanguageSwitcher() {
  const { lang, setLang } = useTranslation();

  return (
    <button
      data-testid="language-switcher"
      onClick={() => setLang(lang === 'en' ? 'vi' : 'en')}
      title={lang === 'en' ? 'Switch to Vietnamese' : 'Chuyển sang tiếng Anh'}
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 px-4 py-2.5 bg-white border border-slate-200/80 shadow-lg rounded-full text-sm font-semibold text-slate-700 hover:shadow-xl hover:border-sky-300 hover:-translate-y-0.5 transition-all duration-200 select-none"
    >
      <span className="text-base leading-none">{lang === 'en' ? '🇻🇳' : '🇬🇧'}</span>
      <span className="text-xs font-bold text-slate-500">{lang === 'en' ? 'VI' : 'EN'}</span>
    </button>
  );
}
